import api from './api';

const categoryMasterService = {
  // Get all categories
  getAllCategories: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.status) queryParams.append('status', params.status);
      if (params.categoryType) queryParams.append('categoryType', params.categoryType);
      if (params.parentCategory !== undefined) queryParams.append('parentCategory', params.parentCategory);
      if (params.search) queryParams.append('search', params.search);

      const queryString = queryParams.toString();
      const url = `/category-master${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching categories:', error);
      throw error;
    }
  },

  // Get category by ID
  getCategoryById: async (id) => {
    try {
      const response = await api.get(`/category-master/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching category:', error);
      throw error;
    }
  },

  // Get next category code
  getNextCategoryCode: async () => {
    try {
      const response = await api.get('/category-master/code/next');
      return response.data;
    } catch (error) {
      console.error('Error fetching next category code:', error);
      throw error;
    }
  },

  // Create category
  createCategory: async (categoryData) => {
    try {
      const response = await api.post('/category-master', categoryData);
      return response.data;
    } catch (error) {
      console.error('Error creating category:', error);
      throw error;
    }
  },

  // Update category
  updateCategory: async (id, categoryData) => {
    try {
      const response = await api.put(`/category-master/${id}`, categoryData);
      return response.data;
    } catch (error) {
      console.error('Error updating category:', error);
      throw error;
    }
  },

  // Delete category
  deleteCategory: async (id) => {
    try {
      const response = await api.delete(`/category-master/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting category:', error);
      throw error;
    }
  },

  // Get category statistics
  getCategoryStats: async () => {
    try {
      const response = await api.get('/category-master/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching category statistics:', error);
      throw error;
    }
  }
};

export default categoryMasterService;

